<template>
    <div>
        <div class="container d-flex align-items-center vh-100 justify-content-center">
            <div>
                <div class="text-center">
                    <div class="logo-wrapper">
                        <img src="@/assets/img/bau-logo-for-light.png"/>
                    </div>
                </div>
                <div class="text-center my-5">
                    <span>
                        <i class="ri-emotion-sad-line ri-8x m-0 p-0"></i>
                    </span>
                    <h4 class="mb-5">Due to technical issues, My BAU system is currently unavailable. We are working to resolve the problem as quickly as possible. Thank you for your patience.</h4>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'Error404',
        methods: {
            goBack() {
                this.$router.push('/')
            }
        }
    }
</script>
